export default __webpack_public_path__ + "static/sharing-logo-ee4d8350ec04e5aa89efa8e4225ba5df.jpg";